import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Form, FormFeedback, Label, Input, Button } from 'reactstrap';

// Validation Schema
const WishlistSchema = yup.object().shape({
  wishlistName: yup.string().required("Please enter your wishlist name"),
});

const WishlistForm = (props) => {
  const { tableData, currentModalName } = props;
  console.log('props', props)

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(WishlistSchema),
    defaultValues: { wishlistName: '' }
  });

  useEffect(() => {
    if (tableData && tableData.wishlist_name) {
      setValue('wishlistName', tableData.wishlist_name);
    }
  }, [tableData, setValue]);

  const handleFormSubmit = (data) => {
    // onSubmit(data.wishlistName);
  };

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)} className="wishlist-form">
      <div className="form-group">
        <Label className="form-label" for="wishlistName">Enter Wishlist Name</Label>
        <Controller
          id="wishlistName"
          name="wishlistName"
          control={control}
          render={({ field }) => (
            <Input
              type="text"
              placeholder="Enter wishlist name"
              invalid={errors.wishlistName && true}
              {...field}
            />
          )}
        />
        {errors.wishlistName && <FormFeedback>{errors.wishlistName.message}</FormFeedback>}
      </div>
      <div className='py-4 d-flex justify-content-end gap-2'>
        <button type='submit' className='btn' style={{ backgroundColor: '#FBBD34', color: 'white' }}>
            {currentModalName == 'Edit Wishlist' ? 'Save' : 'Create'}
        </button>
      </div>
    </Form>
  );
};

export default WishlistForm;
